import { Route } from "react-router-dom";
import { FaHome, FaUser, FaFileInvoiceDollar, FaClipboardList } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import { LoginPage } from "./pages/login/Login";
import { CadastroPage } from "./pages/cadastro/Cadastro";
import { QuestionarioPage } from "./pages/questionario/Questionario";
import { LogoutPage } from "./pages/logout/Logout";
import { HomePage } from "./pages/home/Home";
import { UsuarioPage } from "./pages/usuario/Usuario";
import { FornecedorPage } from "./pages/fornecedor/Fornecedor";
import { PrivateRoute } from "./components/shared/PrivateRoute/PrivateRoute";
import { NotFound, Unauthorized, Forbidden } from "./components/shared/errors/Errors";
import { PropostaPage } from "./pages/proposta/Proposta";
import { VisualizacaoFornecedorPage } from "./pages/fornecedor/visualizacao/Visualizacao";
import { FinalizacaoRoute } from "./components/shared/PrivateRoute/FinalizacaoRoute";
import { AlteracaoFornecedorPage } from "./pages/fornecedor/alteracao/Alteracao";
import { VisualizacaoPropostaPage } from "./pages/proposta/visualizacao/Visualizacao";
import { BsBellFill } from "react-icons/bs";
import { PendenciaPage } from "./pages/pendencias/Pendencias";
import { OrdemCompraPage } from "./pages/ordemCompra/OrdemCompra";

export const getSidebarItems = (codope) => [
  { url: "/home", description: "Home", icon: <FaHome size={18} />, roles: ["COMPRADOR", "FORNECEDOR"] },
  { url: "/pendencias", description: "Pendências", icon: <BsBellFill size={18} />, roles: ["COMPRADOR"] },
  { url: codope ? `/fornecedores/${codope}` : "#", description: "Cadastro", icon: <FaUser size={18} />, roles: ["FORNECEDOR"] },
  { url: "/fornecedores", description: "Fornecedores", icon: <FaUser size={18} />, roles: ["COMPRADOR"] },
  { url: "/ordens-compra", description: "Ordens", icon: <FaClipboardList size={18} />, roles: ["FORNECEDOR"] },
  { url: "/propostas", description: "Propostas", icon: <FaFileInvoiceDollar size={18} />, roles: ["FORNECEDOR", "COMPRADOR"] },
  { url: "/logout", description: "Sair", icon: <MdLogout size={18} />, roles: ["COMPRADOR", "FORNECEDOR"] },
];

export const PublicRoutes = (
  <>
    <Route path="/" element={<LoginPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/cadastro" element={<CadastroPage />} />
    <Route path="/logout" element={<LogoutPage />} />
  </>
);

export const SidebarPrivateRoutes = (
  <>
    <Route element={<PrivateRoute allowedRoles={['COMPRADOR', 'FORNECEDOR']} />}>
      <Route path="/home" element={<HomePage />} />
      <Route path="/perfil" element={<UsuarioPage />} />
      <Route path="/propostas" element={<PropostaPage />} />
      <Route path="/propostas/:id" element={<VisualizacaoPropostaPage />} />
      <Route path="/fornecedores/:id" element={<VisualizacaoFornecedorPage />} />
    </Route>

    <Route element={<FinalizacaoRoute />}>
      <Route path="/finalizacao_cadastro" element={<QuestionarioPage />} />
    </Route>

    <Route element={<PrivateRoute allowedRoles={['FORNECEDOR']} />}>
      <Route path="/ordens-compra" element={<OrdemCompraPage />} />
    </Route>

    <Route element={<PrivateRoute allowedRoles={['COMPRADOR']} />}>
      <Route path="/fornecedores" element={<FornecedorPage />} />
      <Route path="/fornecedores/alteracao" element={<AlteracaoFornecedorPage />} />
      <Route path="/pendencias" element={<PendenciaPage />} />
    </Route>
  </>
);

export const ErrorRoutes = (
  <>
    <Route path="*" element={<NotFound />} />
    <Route path="/401" element={<Unauthorized />} />
    <Route path="/403" element={<Forbidden />} />
  </>
);
